import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'
import { useUser } from '../user/useUser'

export const ENTITLED_CHALLENGE_IDS_QUERY_KEY = (userID: string) =>
  ['entitledChallengeIds', userID] as const

export function useEntitledChallengeIds() {
  const { data: user } = useUser()

  return useQuery({
    queryKey: ENTITLED_CHALLENGE_IDS_QUERY_KEY(user?.id ?? ''),
    queryFn: () => dataSource.getFulfilledPurchaseChallengeIds(user!.id),
    enabled: !!user?.id,
  })
}
